import { render } from "./Holidays.vue?vue&type=template&id=6ccd30ac&scoped=true&ts=true"
import script from "./Holidays.vue?vue&type=script&lang=ts"
export * from "./Holidays.vue?vue&type=script&lang=ts"

import "./Holidays.vue?vue&type=style&index=0&id=6ccd30ac&lang=scss&scoped=true"

import exportComponent from "/home/runner/_work/SDD-gotime-web-client/SDD-gotime-web-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ccd30ac"]])

export default __exports__